import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import for navigation
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import "./Upload.css";
import { BASE_URL } from "./Constants";

const Upload = () => {



  
  const [formData, setFormData] = useState({
      emp_code: "",
      emp_name: "",
      designation: "",
      dept: "",
      band: "",
      questionData: [],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


    useEffect(() => {
      const token = localStorage.getItem("authToken");
      console.log(token);
      const fetchProfile = async () => {
        try {
          const response = await fetch(`${BASE_URL}profile`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          });
          const data = await response.json();
          console.log("Profile data:", data); // Debugging
        } catch (err) {
          console.error("Error fetching profile:", err);
        }
      };
      fetchProfile();
    }, []);
  

  const handleInputChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });

      // Fetch employee details when emp_code is updated
      if (name === "emp_code" && value.trim() !== "") {
          fetchEmployeeDetails(value);
      }
  };

  const fetchEmployeeDetails = async (empCode) => {
      setLoading(true);
      setError(null);

      try {
          const token = localStorage.getItem("authToken");
          const response = await fetch(`${BASE_URL}/getEmployee?emp_code=${empCode}`, {
             
            
            
            method: "GET",
              headers: {
                  // Authorization: `Bearer ${token}`,
                  'Authorization': `Bearer ${localStorage.getItem('token')}`,
                  "Content-Type": "application/json",
              },
          });

          

          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const result = await response.json();
          if (result.status) {
              setFormData({
                  ...formData,
                  emp_code: empCode,
                  emp_name: result.data.comp_name,
                  designation: result.data.designation_name,
                  dept: result.data.dept_name,
                  band: result.data.grade,
                  questionData: result.question_data,
              });
          } else {
              setError(result.message);
          }
      } catch (error) {
          console.error("Fetch error:", error);
          setError("Failed to fetch employee details");
      } finally {
          setLoading(false);
      }
  };

  return (
      <div className="container-scroller">
          <Navbar />
          <div className="container-fluid page-body-wrapper" style={{ marginTop: "-55px" }}>
              <Sidebar />
              <div className="main-panel">
                  <div className="content-wrapper">
                      <div className="col-md-12 grid-margin">
                          <div className="container-fluid">
                              <div className="row mb-2">
                                  <div className="col-sm-6">
                                      <h4 className="m-0">Employee Details</h4>
                                  </div>
                              </div>
                          </div>
                          <br />
                          <div className="card">
                              <div className="card-body">
                                  <form>
                                      <div className="row">
                                          <div className="col-md-4">
                                              <div className="form-group">
                                                  <label style={{ fontSize: "12px" }}>
                                                      <b>Emp Code</b>
                                                  </label>
                                                  <input
                                                      type="text"
                                                      name="emp_code"
                                                      className="form-control input-font"
                                                      value={formData.emp_code}
                                                      onChange={handleInputChange}
                                                  />
                                              </div>
                                          </div>
                                          <div className="col-md-4">
                                              <div className="form-group">
                                                  <label style={{ fontSize: "12px" }}>
                                                      <b>Name</b>
                                                  </label>
                                                  <input
                                                      type="text"
                                                      name="emp_name"
                                                      className="form-control input-font"
                                                      value={formData.emp_name}
                                                      readOnly
                                                  />
                                              </div>
                                          </div>
                                          <div className="col-md-4">
                                              <div className="form-group">
                                                  <label style={{ fontSize: "12px" }}>
                                                      <b>Designation</b>
                                                  </label>
                                                  <input
                                                      type="text"
                                                      name="designation"
                                                      className="form-control input-font"
                                                      value={formData.designation}
                                                      readOnly
                                                  />
                                              </div>
                                          </div>
                                      </div>
                                      <div className="row">
                                          <div className="col-md-4">
                                              <div className="form-group">
                                                  <label style={{ fontSize: "12px" }}>
                                                      <b>Department</b>
                                                  </label>
                                                  <input
                                                      type="text"
                                                      name="dept"
                                                      className="form-control input-font"
                                                      value={formData.dept}
                                                      readOnly
                                                  />
                                              </div>
                                          </div>
                                          <div className="col-md-4">
                                              <div className="form-group">
                                                  <label style={{ fontSize: "12px" }}>
                                                      <b>Band</b>
                                                  </label>
                                                  <input
                                                      type="text"
                                                      name="band"
                                                      className="form-control input-font"
                                                      value={formData.band}
                                                      readOnly
                                                  />
                                              </div>
                                          </div>
                                      </div>
                                      <button type="submit" className="btn btn-primary me-2">
                                            Submit
                                        </button>

                                        
{/* <table className="table table-border">

 {formData.questionData && formData.questionData.length > 0 ? (
      formData.questionData.map((item, index) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.question}</td>
          <td>{item.ans}</td>
          <td>{item.score}</td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="4">No question data available</td>
      </tr>
    )}
</table> */}
<div className="col-md-12">
  <div className="row">
    {formData.questionData && formData.questionData.length > 0 ? (
      formData.questionData.map((item, index) => (
        <div className="row" key={index} style={{ borderBottom: '1px solid #ccc', padding: '10px 0' }}>
          <div className="col-md-1">{index + 1}</div>
          <div className="col-md-5">{item.question}</div>
          <div className="col-md-4">{item.ans}</div>
          <div className="col-md-2">{item.score}</div>
        </div>
      ))
    ) : (
      <div className="col-md-12">No question data available</div>
    )}
  </div>
</div>


                                    </form>
                                    {loading && <p>Loading...</p>}
                                    {error && <p style={{ color: "red" }}>{error}</p>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer className="footer">
                        <div className="d-sm-flex justify-content-center justify-content-sm-between">
                            <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">
                                Copyright © {new Date().getFullYear()}. Vijaya Diagnostic Centre
                            </span>
                        </div>
                    </footer>
                </div>
            </div>
        </div>
    );
};

export default Upload;